import React, { useEffect, useRef, useState } from "react";
import {
  calculateFanZoneOffsets,
  calculateSeatOffsets,
  calculateTextFigureOffsets,
} from "./helper/offsets";
import {
  updateFanZonePositions,
  updateSeatPositions,
  updateTextFigurePositions,
} from "./helper/updatePositions";

export const useMouseMove = (
  schemaRef: React.RefObject<HTMLDivElement>,
  editMode: boolean,
  selectItemMode: boolean,
  data: any,
  setData: React.Dispatch<React.SetStateAction<any>>,
  setText: React.Dispatch<React.SetStateAction<Record<string, any>>>,
  selectedDots: Record<string, any>,
  selectedTextFigures: Record<string, any>,
  selectedFanZones: Record<string, any>,
  setBlockSelection: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [isDragging, setIsDragging] = useState(false);
  const dragOffsets = useRef<{ [key: string]: { x: number; y: number } }>({});

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (
        !editMode ||
        (Object.keys(selectedDots).length === 0 &&
          Object.keys(selectedTextFigures).length === 0 &&
          Object.keys(selectedFanZones).length === 0)
      )
        return;

      if (!schemaRef.current?.contains(event.target as Node)) return;

      setIsDragging(true);
      setBlockSelection(true);
      document.body.style.cursor = "move";

      dragOffsets.current = {
        ...calculateSeatOffsets(event, selectedDots, data),
        ...calculateTextFigureOffsets(event, selectedTextFigures, data),
        ...calculateFanZoneOffsets(event, selectedFanZones, data),
      };

      event.preventDefault();
    };

    const handleMouseMove = (event: MouseEvent) => {
      if (!schemaRef.current?.contains(event.target as Node)) return;
      if (!isDragging) return;

      setData((prevData: any) => {
        const draft = JSON.parse(JSON.stringify(prevData));

        updateSeatPositions(event, selectedDots, draft, dragOffsets.current);
        updateTextFigurePositions(
          event,
          selectedTextFigures,
          draft,
          dragOffsets.current
        );
        updateFanZonePositions(
          event,
          selectedFanZones,
          draft,
          dragOffsets.current
        );

        setText(draft.properties.text);
        return draft;
      });
    };

    const handleMouseUp = () => {
      if (editMode && selectItemMode) setBlockSelection(false);
      setIsDragging(false);
      dragOffsets.current = {};
      document.body.style.cursor = "default";
    };

    window.addEventListener("mousedown", handleMouseDown);
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousedown", handleMouseDown);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [
    isDragging,
    selectedDots,
    selectedTextFigures,
    selectedFanZones,
    editMode,
    schemaRef,
    setBlockSelection,
    data,
    setData,
    setText,
    selectItemMode,
  ]);

  return null;
};
